import React from 'react'

const SVG = ({
  style = { position: 'absolute', fill: '#0696d7' },
  viewBox = '0 0 18 18',
  width = '18',
  height = '18',
  ...rest
}) => (
<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <g id="info-icon" transform="translate(.001)">
        <path d="M9 1.44A7.56 7.56 0 1 1 1.44 9 7.56 7.56 0 0 1 9 1.44M9 0a9 9 0 1 0 9 9 9 9 0 0 0-9-9z"/>
        <path d="M0 0h1.8v5.544H0z" transform="translate(8.1 8.299)"/>
        <circle cx="1.26" cy="1.26" r="1.26" transform="translate(7.74 4.158)"/>
    </g>
</svg>
)
export default SVG
